// initial state
const state = () => ({
  show: false
});

const getters = {
  isShow: (state) => state.show
};

const actions = {
  show({ commit }) {
    commit('show');
  },
  close({ commit }) {
    commit('close');
  },
};

// mutations
const mutations = {
  show(state) {
    state.show = true;
  },
  close(state) {
    state.show = false;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations
};
